import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a44540d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "geoDataListModal" }
const _hoisted_2 = {
  key: 1,
  class: "geoDataListModalContainer px-6 pb-5 pt-0"
}
const _hoisted_3 = { class: "geoDataListModalContent overflow-y-auto" }
const _hoisted_4 = {
  key: 4,
  class: "flex flex-col items-center"
}
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = {
  key: 5,
  class: "flex flex-row items-center w-44"
}
const _hoisted_8 = {
  key: 6,
  class: "flex flex-col mr-2"
}
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }

import { strapiUrl } from '@/api/api';
import FragenblockContent from '@/components/FragenblockContent.vue';
import useScreenSize from '@/composables/useScreenSize';
import { useStore } from "@/composables/useTypedStore";
import useUser from '@/composables/useUser';
import { Fragenblock } from '@/models/ba/Fragenblock';
import StrapiMedia from '@/models/photo/strapi-media.model';
import User from '@/models/user';
import { IonContent, IonIcon, IonImg, IonItem, IonLabel, IonList, IonHeader, IonToolbar, IonButtons, IonButton } from '@ionic/vue';
import {
  calendarClearOutline,
  createOutline,
  eyeOutline,
  timeOutline,
  closeOutline,
  helpOutline,
  arrowBackOutline
} from "ionicons/icons";
import moment from "moment";
import QueryString from 'qs';
import { computed, nextTick, onMounted, PropType, reactive, ref, watch } from 'vue';

const avatarPlaceholderUrl = "./assets/img/profiles/placeholder_profile_image.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoDataListModal',
  props: {
  data: {
    type: Array as PropType<Array<Fragenblock>>,
    default: () => [],
    required: false
  },
  preselectedItem: {
    type: Object as PropType<Fragenblock>,
    default: undefined,
    required: false
  }
},
  emits: ["dismiss", "delete", "selectionChanged"],
  setup(__props, { emit }) {

const props = __props;





const { user } = useUser();
const { isMinMedium, isMaxXSmall } = useScreenSize();
const store = useStore();

const users = reactive<Record<number, any>>({});
const selectedItem = ref<Fragenblock | undefined>(props.preselectedItem);

const isOnline = computed(() => {
  return store.getters["app/isOnline"];
});

const fetchUsers = async () => {
  const query = {
    filters: {
      $or: props.data
        .filter((item: Fragenblock) => item.config?.userId)
        .map((item: Fragenblock) => {
          return { id: { $eq: item.config.userId } };
        })
    }
  };

  const response = (await User.api().get(`/users/?${QueryString.stringify(query)}`, { save: false })).response;
  if (response?.data) {
    response.data.forEach((fetchedUser: User) => {
      const profilePhoto = (fetchedUser?.profilbild as StrapiMedia)?.formats?.thumbnail?.url ?? null;
      const isSameOrganisation = fetchedUser.organisation?.id === user.value?.organisation?.id;
      users[fetchedUser.id] = {
        name: fetchedUser?.username && isSameOrganisation ? fetchedUser.username : null,
        picture: profilePhoto && isSameOrganisation ? `${strapiUrl}${profilePhoto}` : avatarPlaceholderUrl
      };
    });
  }
};

const addCurrentUserInfo = () => {
  if (user.value) {
    const profilePhoto = (user.value.profilbild as StrapiMedia)?.formats?.thumbnail?.url ?? null;
    users[user.value.id] = {
      name: user.value.username ?? null,
      picture: user.value.profilbild ? `${strapiUrl}${profilePhoto}` : avatarPlaceholderUrl
    };
  }
};

const deleteFragenblock = () => {
  emit("delete", selectedItem.value);
  nextTick(() => {
    selectedItem.value = undefined;
  });
};

watch(isOnline, async (value) => {
  if (value) {
    fetchUsers();
  }
});

watch(() => props.preselectedItem, (value) => {
  selectedItem.value = value;
});

watch(selectedItem, (value) => {
  emit("selectionChanged", value)
}, { immediate: true });

onMounted(() => {
  if (isOnline.value) {
    fetchUsers();
  } else {
    addCurrentUserInfo();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            (selectedItem.value)
              ? (_openBlock(), _createBlock(_unref(IonButtons), {
                  key: 0,
                  slot: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(arrowBackOutline),
                      class: "ml-4 w-5 h-5 cursor-pointer hover:shadow rounded-full",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedItem.value = undefined))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(closeOutline),
                  class: "mr-4 w-5 h-5 cursor-pointer hover:shadow rounded-full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dismiss')))
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { color: "light" }, {
      default: _withCtx(() => [
        (selectedItem.value)
          ? (_openBlock(), _createBlock(FragenblockContent, {
              key: 0,
              "fragenblock-base": (selectedItem.value as Fragenblock),
              "modal-depth": 1,
              "survey-map-modal": true,
              onDelete: deleteFragenblock
            }, null, 8, ["fragenblock-base"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(IonList), { class: "p-0 mt-0 rounded" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: item.id,
                        class: _normalizeClass(["cursor-pointer", { 'reduce-item-padding': !_unref(isMinMedium) && _unref(isMaxXSmall) }]),
                        onClick: ($event: any) => (selectedItem.value = item)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.frages![0].eingabeText), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (!item.config?.userId || !users[item.config.userId]?.name)
                            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 0,
                                icon: _unref(helpOutline),
                                class: "mr-4 w-5 h-5 opacity-50 rounded-full overflow-hidden bg-transparent"
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_unref(IonImg), {
                                key: 1,
                                src: item.config?.userId ? users[item.config.userId]?.picture : avatarPlaceholderUrl,
                                alt: _ctx.$t('einstellungen.profilbild'),
                                class: "mr-2 w-8 h-8 rounded-full overflow-hidden bg-transparent"
                              }, null, 8, ["src", "alt"])),
                          (item.config?.userId && users[item.config.userId]?.name)
                            ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(users[item.config.userId].name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createBlock(_unref(IonLabel), {
                                key: 3,
                                class: "opacity-75"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("hzba.geoDataList.unknownUser")), 1)
                                ]),
                                _: 1
                              })),
                          (_unref(isMaxXSmall))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(moment)(item.createdAt).format("DD.MM.YY")), 1),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(moment)(item.createdAt).format("HH:mm")), 1)
                              ]))
                            : (_unref(isMinMedium))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(calendarClearOutline),
                                    class: "mr-1",
                                    title: _ctx.$t('hzba.geoDataList.createdAt')
                                  }, null, 8, ["icon", "title"]),
                                  _createTextVNode(" " + _toDisplayString(_unref(moment)(item.createdAt).format("DD.MM.YYYY")) + " ", 1),
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(timeOutline),
                                    class: "ml-1 mr-0.5"
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString(_unref(moment)(item.createdAt).format("HH:mm")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _createElementVNode("span", _hoisted_9, [
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(calendarClearOutline),
                                      class: "mr-1",
                                      title: _ctx.$t('hzba.geoDataList.createdAt')
                                    }, null, 8, ["icon", "title"]),
                                    _createTextVNode(" " + _toDisplayString(_unref(moment)(item.createdAt).format("DD.MM.YY")), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_10, [
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(timeOutline),
                                      class: "ml-2 mr-1"
                                    }, null, 8, ["icon"]),
                                    _createTextVNode(" " + _toDisplayString(_unref(moment)(item.createdAt).format("HH:mm")), 1)
                                  ])
                                ])),
                          (_unref(user)?.id && item.config?.userId === _unref(user).id)
                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 7,
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    class: _normalizeClass(_unref(isMaxXSmall) ? 'w-3 h-3' : 'w-4 h-4'),
                                    icon: _unref(createOutline)
                                  }, null, 8, ["class", "icon"])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 8,
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "icon-only",
                                    class: _normalizeClass(_unref(isMaxXSmall) ? 'w-3 h-3' : 'w-4 h-4'),
                                    icon: _unref(eyeOutline)
                                  }, null, 8, ["class", "icon"])
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})